import * as React from 'react';
import { useEffect } from 'react';
import { withRouter } from 'react-router';
import PageContent from '../../components/PageContent';
import { ContentPage, TContentState } from '../../types/Content';
import AddToHomeScreen from '../../components/AddToHomeScreen';
import { useApp } from '../../hooks/useApp';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from '../../store/Store';
import { getFavoritePages } from '../../actions/ContentActions';
import WelcomeSection from '../../components/home/WelcomeSection';

const HomePage: React.FC = (): JSX.Element => {
  const { app } = useApp();
  const contentState: TContentState = useSelector<IAppState, TContentState>(
    state => state.contentState
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFavoritePages());
  }, [dispatch]);

  return (
    <>
      <PageContent
        pageType={ContentPage.FRONTPAGE}
        showAsCard={true}
        frontpageList={contentState.favoritePages}
        beforeFavorites={<WelcomeSection />}
      />
      {!app.isLoading() &&
        !window.matchMedia('(display-mode: standalone)').matches && (
          <AddToHomeScreen />
        )}
    </>
  );
};

export default withRouter(HomePage);
